var _defs, _rect, _path, _path2, _rect2, _path3, _path4, _path5, _rect3, _polygon, _rect4, _rect5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _polygon2, _line9, _line10, _line11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpBlueprintIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.g{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.b,.c,.e,.f{fill-rule:evenodd;}.c,.f{fill:#fff;}.d{fill:#ffefe0;}.e,.f,.g{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-blueprint-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.26,129.91H134.81V34.23H20.26a9.07,9.07,0,0,1-9.07-9.07v95.69A9.07,9.07,0,0,0,20.26,129.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.26,123.91H128.81V28.23H14.26a9.07,9.07,0,0,1-9.07-9.07v95.69A9.07,9.07,0,0,0,14.26,123.91Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 66.86,
    y: 28.23,
    width: 61.95,
    height: 95.69
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M14.26,123.91H128.81V28.23H14.26a9.07,9.07,0,0,1-9.07-9.07v95.69A9.07,9.07,0,0,0,14.26,123.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.19,22.69h.71a9.07,9.07,0,0,0,8.36,5.54H29.33v95.69H14.26a9.07,9.07,0,0,1-9.07-9.07Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M5.19,19.16a9.07,9.07,0,0,1,18.14,0v95.69a9.07,9.07,0,1,0-18.14,0Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 46.9,
    y: 65.81,
    width: 39.91,
    height: 27.47
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "66.86 44.63 79.57 55.22 92.28 65.81 66.86 65.81 41.44 65.81 54.15 55.22 66.86 44.63"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 54.23,
    y: 71.56,
    width: 9.99,
    height: 8.39
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 69.73,
    y: 71.56,
    width: 9.99,
    height: 21.73
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 73.48,
    y1: 44.63,
    x2: 104.05,
    y2: 44.63
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 91.55,
    y1: 93.28,
    x2: 104.05,
    y2: 93.28
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 100.05,
    y1: 44.63,
    x2: 100.05,
    y2: 93.28
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 105.05,
    y1: 65.54,
    x2: 105.05,
    y2: 72.37
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 46.9,
    y1: 107.27,
    x2: 46.9,
    y2: 97.61
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 86.82,
    y1: 107.27,
    x2: 86.82,
    y2: 97.61
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 46.9,
    y1: 103.27,
    x2: 86.82,
    y2: 103.27
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 70.27,
    y1: 108.27,
    x2: 63.45,
    y2: 108.27
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "59.23 44.63 53.36 44.63 53.36 55.88 59.4 50.88 59.23 44.63"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 99.57,
    y1: 112.92,
    x2: 116.01,
    y2: 112.92
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 99.57,
    y1: 107.97,
    x2: 116.01,
    y2: 107.97
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 99.57,
    y1: 103.02,
    x2: 116.01,
    y2: 103.02
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpBlueprintIcon);
export default __webpack_public_path__ + "static/media/CP-blueprint-icon.666722e2cad76e4b49296e0065b0aecd.svg";
export { ForwardRef as ReactComponent };